import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { WpProvider } from '../../providers/wp/wp';


/*
 Generated class for the InRoomDiningServiceProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class InRoomDiningServiceProvider {


  phcApp;
  testing = false;

  constructor(public http: HttpClient, wpProvider: WpProvider) {
    console.log('Hello InRoomDiningServiceProvider Provider');
    this.phcApp = wpProvider.app;
  }


  submitOrder(order){
    console.log(this.phcApp.in_room_dining);

    let html = order.createHtmlDescription();


    const options = {
      html,
      to: this.phcApp.in_room_dining.order_recipient_email || 'dr@dawar.ca',
      subject: `${order.firstName} ${order.lastName} in ${order.room} ordered in-room dining`,
      phone: this.phcApp.in_room_dining.order_recipient_phone || '',
    };

    if (this.testing) {
      options.to = 'dr@dawar.ca';
      options.phone = '+16479973274';
    }

    this.http.post('https://phc-dev.eventerac.com/wp-json/phc/v1/submit-order', options).subscribe((resp) => {
      console.log(resp);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/in-room-dining/in-room-dining-service.ts